import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import ArchiveContextProvider from './archive-context';
import ArchiveGrid from './components/archive-grid';
import HeaderRow from './components/archive-header-row';
import { messages } from './messages';
import archiveStyle from './style.module.less';
import ErrorBoundary from '../../../components/error-boundary';
import style from '../../grid-page.module.less';

const ArchivePage = () => {
  return (
    <div className={archiveStyle['grid-page']}>
      <div className={style['main-content']}>
        <div className={archiveStyle['grid-header']}>
          <FormattedMessage {...messages.archiveGridLabel} />
        </div>
        <div className={archiveStyle['archive-grid-description']}>
          <FormattedMessage {...messages.archiveGridDescription} />
        </div>
        <div className={style['grid-content']}>
          <div className={classnames(style['grid-and-footer'], style['no-sidebar'])}>
            <div className={archiveStyle.grid}>
              <ErrorBoundary errorMessageId='archiveGrid'>
                <HeaderRow />
                <ArchiveGrid />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default () => {
  return (
    <ArchiveContextProvider>
      <ArchivePage />
    </ArchiveContextProvider>
  );
};
